import script from "./statusChanger.vue?vue&type=script&setup=true&lang=ts"
export * from "./statusChanger.vue?vue&type=script&setup=true&lang=ts"

import "./statusChanger.vue?vue&type=style&index=0&id=130b71f5&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-130b71f5"]])

export default __exports__